import { DashboardStore } from "services/dashboard/stores/dashboard";
import { DashboardSettingsStore } from "services/dashboard/stores/dashboard-settings";
import { IStore } from "services/indexdb/interface/istore";
import { DeviceStore } from "./device";
import { QueryStore } from "./query";
import { QuerySettingsStore } from "./query-settings";
import { SourceStore } from "./source";
import { SourceDefinitionStore } from "./source-definition";

export const Stores: Array<IStore> = [
    SourceStore,
    DeviceStore,
    SourceDefinitionStore,
    QueryStore,
    QuerySettingsStore,
    DashboardSettingsStore, 
    DashboardStore
]